import { useContext, createElement } from 'react';
// @ts-ignore untyped JS module
import { classNameFix, getPassThroughProps, getValue } from './utils';
import { I18nHMRContext } from '../internal/i18n-internal';

const DEFAULT_OPTIONS = {};

export interface FormattedHTMLMessageProps {
  message: string;
  className?: string;
  class?: string;
  options?: object;
  useGap?: boolean;
}

function FormattedHTMLMessage({
  useGap = false,
  message,
  options = DEFAULT_OPTIONS,
  ...rest
}: FormattedHTMLMessageProps) {
  useContext(I18nHMRContext);

  const props = classNameFix(
    getPassThroughProps({ useGap, message, options, ...rest })
  );

  // must use dangerouslySetInnerHTML prop to display embedded HTML
  return createElement('i18n-string', {
    ...props,
    dangerouslySetInnerHTML: {
      __html: getValue({ useGap, message, options }),
    },
  });
}

FormattedHTMLMessage.displayName = 'FormattedHTMLMessage';
FormattedHTMLMessage.isI18nElement = true;

export default FormattedHTMLMessage;
